import { render, staticRenderFns } from "./CompaniesListItem.vue?vue&type=template&id=5f242560&"
import script from "./CompaniesListItem.vue?vue&type=script&lang=js&"
export * from "./CompaniesListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports